import { useMemo } from 'react';
import { useFeatureValue } from '@shared/core/featureFlags';

/*
 * Interface for the TargetPrintDialogPayload remote feature flag payload.
 */
interface TargetPrintDialogPayload {
  delayLengthInHours: number;
}

/*
 * Type predicate function to validate the TargetPrintDialogPayload remote feature flag payload.
 * @param {any} payload - The payload to validate.
 * @returns {boolean}
 */
export const isTargetPrintDialogPayload = (payload: unknown): payload is TargetPrintDialogPayload => {
  return !!(payload && typeof payload === 'object' && 'delayLengthInHours' in payload && typeof payload.delayLengthInHours === 'number');
};

// Fallback content if we do not get content from the remote feature flag.
const DEFAULT_RETARGET_TRAVEL_DIALOG_DELAY = { delayLengthInHours: 24 };

/*
 * Hook to retrieve and validate the remote feature flag value for Retarget Travel Dialog.
 */
export function useTargetPrintEarlyAccessDialogDelay(): { delayLengthInHours: number } {
  const { payload: retargetTravelDialogDelayPayload } = useFeatureValue('printAdminDashboardTargetPrintDialogDelay');
  const retargetTravelDelayPayload = useMemo(() => {
    return isTargetPrintDialogPayload(retargetTravelDialogDelayPayload)
      ? { delayLengthInHours: retargetTravelDialogDelayPayload.delayLengthInHours }
      : DEFAULT_RETARGET_TRAVEL_DIALOG_DELAY;
  }, [retargetTravelDialogDelayPayload]);
  return retargetTravelDelayPayload;
}
